import gql from 'graphql-tag'

export const GET_BRANCH_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getBranchPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        addressEn
        addressRu
        addressKg
        telNumber
      }
    }
  }
`;

export const GET_BRANCH_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getBranch (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      addressEn
      addressRu
      addressKg
      telNumber
      showInClientAddress
    }
  }
`;

export const GET_ALL_BRANCHES_QUERY = gql`
  query {
    getAllBranches {
      id
      titleEn
      titleRu
      titleKg
    }
  }
`;
